<template>
  <div class="basic-password-input-container">
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <label class="bordered-bottom">
        <span v-if="displayLabel">{{ label }} {{ validation.split('|').includes('required') ? '*' : '' }}</span>
        <input
          v-bind="field"
          :ref="name"
          type="password"
          class="bordered-bottom password"
          autocomplete="on"
          :placeholder="`${placeholder} ${!displayLabel && validation.split('|').includes('required') ? '*' : ''}`"
        >
        <img
          v-if="![null, undefined, ''].includes(mutatedValue)"
          class="form-generator-clear-button"
          src="@/assets/icons/cancel.svg"
          alt="clear input"
          @click="clearInput"
        >
        <img
          v-if="visibilityToggle"
          class="btn-visibility"
          :src="visibilityBtn ? $image('assets/icons/visibility.svg') : $image('assets/icons/visibility-off.svg')"
          alt="toggle password visibility"
          @click.prevent="toggleVisibility()"
        >
      </label>
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * placeholder: placeholder that'll be set inside the textarea (string)
 * value: text that'll be set inside the input, if null, then the placeholder we'll be displayed (string)
 * name: input's name (string)
 */
export default {
  name: 'BasicPasswordInput',
  components: {
    Field,
    ErrorMessage
  },
  expose: ['clearInput'],
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    defaultValue: [String, Array],
    name: String,
    displayLabel: {
      type: Boolean,
      default: false
    },
    visibilityToggle: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue,
      visibilityBtn: false
    }
  },
  watch: {
    mutatedValue() {
      this.onInput()
    }
  },
  mounted() {
    this.mutatedValue ? this.onInput() : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    onInput() {
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    },
    toggleVisibility() {
      this.visibilityBtn = !this.visibilityBtn
      this.$refs[this.name].type = this.$refs[this.name].type === 'password' ? 'text' : 'password'
    },
    clearInput() {
      this.mutatedValue = ''
      this.onInput()
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-password-input-container {
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    label {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      white-space: nowrap;
      align-items: center;
      padding-left: 0.5rem;

      span {
        width: 30%;
        font-weight: bolder;
        font-size: inherit !important;
      }

      input {
        border: none;
        width: 100%;
      }

      input[type='text'] {
        text-transform: none;
      }

      .form-generator-clear-button {
        margin-left: 5px;
      }

      .btn-visibility {
        height: 1.2rem;
        width: 1.2rem;
        margin-left: 5px;
      }
    }
  }
</style>
